import React from 'react';
import { CircularProgress } from 'lib/@mui';

const Spinner = (props = {}) => {
    return <CircularProgress {...props} />;
};

export default Spinner;
